import React, {Component} from 'react';
import moment from 'moment';

class TimeStampDetails extends Component {

    static defaultProps = {
        format: "YYYY-MM-DD HH:mm",
        label: "",
        empty: "",
        maxWidth: 252,
        data: 0
    };

    constructor(props) {
        super(props);
    }

    render() {
        let data = isNaN(parseInt(this.props.data)) ? 0 : parseInt(this.props.data);
        let result =true;
        if(this.props.condition&&this.props.condition.length){
            if(this.props.condition.indexOf(this.props.dataSource.status)> -1){
                result = false
            }
        }
        return <div style={{display:"inline-block"}}>
            {
                result?<table cellPadding={0} cellSpacing={0} border={0} width={"100%"} style={{margin:"10px 0"}}><tbody><tr>
                    <td width={100} align={"right"} valign={"top"} style={{color: "#aaa6a6"}}>
                        {this.props.label}：
                    </td>
                    <td style={{width:this.props.maxWidth, color:"#252424"}} valign={"top"}>
                        {moment(data).format(this.props.format)}
                    </td>
                </tr></tbody></table>:null
            }
        </div>;
    }
}

export default TimeStampDetails;
